<button #gridViewButton (click)="applyView()" [ngClass]="{ flagged: flagged, selected: selected && !flagged }" class="grid-view-button">
	{{ view }}
	<div *ngIf="removable === true">
		<img (click)="showConfirm($event)" *ngIf="!flagged" [height]="imageHeight" [ngSrc]="crossIcon" [width]="imageWidth" alt="crossIcon" />
		<img (click)="confirmDelete($event)" *ngIf="flagged" [height]="imageHeight" [ngSrc]="trashIcon" [width]="imageWidth" alt="trashIcon" />
	</div>
</button>
